export default __webpack_public_path__ + "static/media/green-radio.dae0621e.svg";